<h1 class='aviso'>Aviso</h1>
<h2 class='aviso2'>Usted tiene alguna de sus licencias caducadas o próximas a caducar</h2>
<h2 class='aviso2'>Por favor, vaya al apartado de <span>Licencias</span> para renovarlas</h2>
